import React, { useCallback, useEffect, useState } from 'react';
import axiosInstance from '../../utils/axiosConfig';
import { useAuth } from '../../contexts/AuthContext';
import TakipFormModal from './TakipFormModal';
import TakipKart from './TakipKart';
import { IlgiliKayit, IlgiliTur, TakipOzet, ilgiliMeta, takipAc, TAKIP_DEGISTI_OLAYI } from './takipOrtak';
import './takip.css';

// Kayıt sayfalarına (müşteri, potansiyel müşteri, sözleşme, sunum, proje, emlak, kiralık, kat karşılığı) konan "Takip" düğmesi:
// kayda bağlı takip sayısını gösterir, tıklanınca kaydın takiplerini listeler ve yeni takip ekletir.
interface Props {
    tur: IlgiliTur;
    anahtar: string | number | null | undefined;
    baslik: string;
    className?: string;
    style?: React.CSSProperties;
}

const KayitTakipButonu: React.FC<Props> = ({ tur, anahtar, baslik, className, style }) => {
    const { user } = useAuth();
    const ben = user?.kullaniciID ?? 0;
    const [liste, setListe] = useState<TakipOzet[] | null>(null);
    const [acik, setAcik] = useState(false);
    const [yeni, setYeni] = useState(false);
    const [tamamlananlar, setTamamlananlar] = useState(false);
    const meta = ilgiliMeta(tur);

    const yukle = useCallback(async () => {
        if (anahtar == null || anahtar === '') return;
        try {
            const r = await axiosInstance.get('/api/Takipler/ilgili', { params: { tur, anahtar: String(anahtar) } });
            setListe(r.data);
        } catch { setListe([]); }
    }, [tur, anahtar]);

    useEffect(() => { yukle(); }, [yukle]);
    useEffect(() => {
        const h = () => yukle();
        window.addEventListener(TAKIP_DEGISTI_OLAYI, h);
        return () => window.removeEventListener(TAKIP_DEGISTI_OLAYI, h);
    }, [yukle]);

    useEffect(() => {
        if (!acik) return;
        const esc = (e: KeyboardEvent) => { if (e.key === 'Escape' && !yeni) setAcik(false); };
        window.addEventListener('keydown', esc);
        return () => window.removeEventListener('keydown', esc);
    }, [acik, yeni]);

    if (anahtar == null || anahtar === '') return null;
    const aciklar = (liste ?? []).filter(t => !t.tamamlandi);
    const bitenler = (liste ?? []).filter(t => t.tamamlandi);
    const ilgili: IlgiliKayit = { tur, anahtar, baslik };

    return (
        <>
            <button type="button" className={`tkp-kayit-btn ${className ?? ''}`} style={style} onClick={() => setAcik(true)}
                title={`Bu ${meta?.ad.toLocaleLowerCase('tr-TR') ?? 'kayıt'} ile ilgili takipler`}>
                <i className="fas fa-tasks"></i>Takip
                {aciklar.length > 0 && <span className="say">{aciklar.length}</span>}
            </button>

            {acik && (
                <div className="tkp-perde" onMouseDown={e => { if (e.target === e.currentTarget) setAcik(false); }}>
                    <div className="tkp-modal dar">
                        <div className="tkp-modal-bas">
                            <i className={`fas ${meta?.ikon ?? 'fa-tasks'}`} style={{ color: '#e67d21' }}></i>
                            <h5 title={baslik}>Takip — {baslik}</h5>
                            <button className="tkp-kapat" onClick={() => setAcik(false)}>×</button>
                        </div>
                        <div className="tkp-modal-govde" style={{ minHeight: 160 }}>
                            {liste === null && <div style={{ textAlign: 'center', padding: 30, color: '#9ca3af' }}><i className="fas fa-spinner fa-spin"></i></div>}
                            {liste && liste.length === 0 && (
                                <div style={{ textAlign: 'center', padding: '28px 0', color: '#9ca3af' }}>
                                    <i className="fas fa-clipboard-list" style={{ fontSize: 30, display: 'block', marginBottom: 8 }}></i>
                                    Bu kayıt için takip yok.
                                </div>
                            )}
                            {aciklar.map(t => <TakipKart key={t.todoID} takip={t} ben={ben} kayitGizle onAc={() => takipAc(t.todoID)} />)}
                            {bitenler.length > 0 && (
                                <>
                                    <div className="tkp-grup-bas" style={{ cursor: 'pointer' }} onClick={() => setTamamlananlar(v => !v)}>
                                        <i className={`fas fa-chevron-${tamamlananlar ? 'down' : 'right'}`}></i>Tamamlanan ({bitenler.length})
                                    </div>
                                    {tamamlananlar && bitenler.map(t => <TakipKart key={t.todoID} takip={t} ben={ben} kayitGizle onAc={() => takipAc(t.todoID)} />)}
                                </>
                            )}
                        </div>
                        <div className="tkp-modal-alt">
                            <button className="tkp-btn" onClick={() => setAcik(false)}>Kapat</button>
                            <button className="tkp-btn turuncu" onClick={() => setYeni(true)}><i className="fas fa-plus"></i>Yeni Takip</button>
                        </div>
                    </div>
                </div>
            )}
            {yeni && <TakipFormModal ilgili={ilgili} onKapat={() => setYeni(false)} />}
        </>
    );
};

export default KayitTakipButonu;
